"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLocaleToLanguage = transformLocaleToLanguage;
function transformLocaleToLanguage(locale) {
    return locale.substr(0, 2).toLowerCase();
}
//# sourceMappingURL=transformLocaleToLanguage.js.map